<template>
  <HeaderApp /> <LoadingProgress v-if="items == null" />
  <div
    id="printDev"
    :class="
      ' mx-2 mt-14 mb-5 p-3 h-full bg-slate-100 dark:bg-bgFullDark rounded-2xl ' +
      (isHide == true
        ? '  '
        : $store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
    v-else
  >
    <InvoiceHeader
      invoice_type="suplier_account_detail"
      v-if="isHide == true"
    />
    <div class="flex lg:flex-row flex-col mb-4 justify-between items-center">
      <div class="flex items-center space-x-4">
        <p class="font-semibold text-xl text-textBlack dark:text-textWhite">
          {{ $t("item_detail") }}
        </p>
        <button
          v-if="item && item.item && $store.getters['checkUserAccess']({ id: '8', action: 'edit' })"
          @click="showEditModal"
          class="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200 no-print"
        >
          <i class="fa-solid fa-pen mr-2"></i>
          {{ $t("edit") }}
        </button>
      </div>
      <div class="w-10"></div>
      <p
        class="font-semibold text-xl text-textBlack dark:text-textWhite"
        v-if="isHide == true"
      >
        {{ startDate }} - {{ endDate }}
      </p>
      <div class="flex lg:flex-row flex-col no-print">
        <div class="lg:flex">
          <div class="md:mx-2 mt-4 lg:mt-0">
            <label
              for="boxType"
              class="block mb-2 text-sm text-textBlack1 dark:text-textWhite1"
              >{{ $t("sale_type") }}
            </label>
            <select
              id="boxType"
              class="bg-white border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-4/6 xl:w-40 lg:w-36 p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              v-model="invoiceType"
              @change="getData"
            >
              <option value="1" selected>{{ $t("sale_tak") }}</option>
              <option value="2">{{ $t("sale_jwmla") }}</option>
              <option value="0">{{ $t("all") }}</option>
            </select>
          </div>
        </div>
        <div class="flex lg:flex-row flex-col">
          <div class="md:mx-2 my-1 md:my-0">
            <label
              for="debtDate"
              class="block mb-2 text-sm font-medium text-textBlack1 dark:text-textWhite1"
              >{{ $t("start_date") }}
            </label>
            <input
              type="date"
              id="debtDate"
              class="bg-white border text-sm border-gray-300 text-textBlack1 placeholder-gray-400 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-4/6 xl:w-40 lg:w-36 p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 remove-arrow"
              v-model="startDate"
              @change="getData"
            />
          </div>

          <div class="md:mx-2 my-1 md:my-0">
            <label
              for="debtDate"
              class="block mb-2 text-sm font-medium text-textBlack1 dark:text-textWhite1"
              >{{ $t("end_date") }}</label
            >
            <input
              type="date"
              id="debtDate"
              class="bg-white border text-sm border-gray-300 text-textBlack1 placeholder-gray-400 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-4/6 xl:w-40 lg:w-36 p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 remove-arrow"
              v-model="endDate"
              @change="getData"
            />
          </div>

          <div class="md:mx-2 my-1 md:my-0">
            <label
              for="boxType"
              class="block mb-2 text-sm text-textBlack1 dark:text-textWhite1"
            >
              {{ $t("choose_period") }}
            </label>
            <select
              id="countries"
              class="bg-white border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block xl:w-40 lg:w-36 w-4/6 p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              v-model="period"
              @change="periodChanged(period)"
            >
              <option value="today" class="my_font">{{ $t("today") }}</option>
              <option value="yesterday" class="my_font">
                {{ $t("yesterday") }}
              </option>
              <option value="last7days" class="my_font">
                {{ $t("last7days") }}
              </option>
              <option value="last30days" class="my_font">
                {{ $t("last30days") }}
              </option>
              <option value="thismonth" class="my_font">
                {{ $t("thismonth") }}
              </option>
              <option value="lastmonth" class="my_font">
                {{ $t("lastmonth") }}
              </option>
              <option value="lastyear" class="my_font">
                {{ $t("lastyear") }}
              </option>
              <option value="thisyear" class="my_font">
                {{ $t("thisyear") }}
              </option>
              <option value="all" class="my_font">{{ $t("all_time") }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="lg:flex w-full mb-12">
      <div class="w-full lg:w-2/5 h-full py-5">
        <!-- Multiple Images Gallery -->
        <div v-if="item.item.i_images && Array.isArray(item.item.i_images) && item.item.i_images.length > 0">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
            <i class="fa-solid fa-images mr-3 text-blue-500"></i>
            {{ $t("item_images") }} ({{ item.item.i_images.length }})
          </h3>
          <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-2 gap-4">
            <div v-for="(imgPath, index) in item.item.i_images" :key="index" class="relative group cursor-pointer" @click="openImageModal(file_url + imgPath)">
              <img :src="file_url + imgPath" :alt="'Image ' + (index + 1)" class="w-full h-48 object-cover rounded-xl border-2 border-gray-200 dark:border-gray-700 hover:opacity-90 hover:border-blue-500 hover:shadow-lg transition-all duration-200 shadow-md" />
              <div class="absolute top-2 right-2 bg-black bg-opacity-75 text-white px-2 py-1 rounded-full text-xs font-semibold shadow-lg pointer-events-none">
                {{ index + 1 }}
              </div>
              <div class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all rounded-xl flex items-center justify-center pointer-events-none">
                <i class="fa-solid fa-expand text-white text-xl opacity-0 group-hover:opacity-100 transition-opacity"></i>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="flex items-center justify-center h-96 bg-gray-100 dark:bg-gray-800 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600">
          <div class="text-center">
            <i class="fa-solid fa-image text-6xl text-gray-400 mb-4"></i>
            <p class="text-gray-500 dark:text-gray-400">{{ $t("no_images") || "No images available" }}</p>
          </div>
        </div>
      </div>

      <div class="flex-col py-2 px-4 w-full lg:w-3/5 h-full">
        <p class="text-textBlack1 dark:text-textWhite1 text-3xl font-semibold">
          {{ item.item.i_name }}
        </p>
        <p class="text-textBlack3 dark:text-textWhite3 text-base pt-4">
          {{ item.item.i_desc }}
        </p>

        <div
          class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mt-6 gap-x-4 gap-y-2"
        >
          <div
            class="flex px-4 py-2 bg-gray-200 items-center rounded-lg w-36 md:w-44 h-20"
          >
            <i class="fa-solid fa-building text-2xl text-gray-500"></i>
            <div class="w-2 md:w-3"></div>
            <div class="flex-col text-sm md:text-base">
              <p class="text-gray-600 font-medium">{{ $t("last_suplier") }}</p>
              <p
                class="text-gray-600 font-semibold"
                v-if="item.item.suplier != null"
              >
                {{ item.item.suplier.su_name }}
              </p>
            </div>
          </div>

          <div
            class="flex px-5 py-4 bg-blue-100 items-center rounded-xl w-36 md:w-44 h-24 shadow-md hover:shadow-lg transition-all"
          >
            <i class="fa-solid fa-user text-3xl text-blue-500"></i>
            <div class="w-4"></div>
            <div class="flex-col text-sm md:text-base">
              <p class="text-blue-500 font-medium mb-1">{{ $t("bought_by") }}</p>
              <p class="text-blue-500 font-semibold">
                {{ item.item.users.name }}
              </p>
            </div>
          </div>

          <div
            class="flex px-5 py-4 bg-pink-200 items-center rounded-xl w-36 md:w-44 h-24 shadow-md hover:shadow-lg transition-all"
          >
            <i class="fa-solid fa-tag text-3xl text-pink-700"></i>
            <div class="w-4"></div>
            <div class="flex-col text-sm md:text-base">
              <p class="text-pink-700 font-medium mb-1">{{ $t("item_category") }}</p>
              <p class="text-pink-700 font-semibold">
                {{ item.item.category.ca_name }}
              </p>
            </div>
          </div>

          <div
            class="flex px-5 py-4 bg-red-200 items-center rounded-xl w-36 md:w-44 h-24 shadow-md hover:shadow-lg transition-all"
          >
            <i class="fa-solid fa-barcode text-3xl text-red-700"></i>
            <div class="w-4"></div>
            <div class="flex-col text-sm md:text-base">
              <p class="text-red-700 font-medium mb-1">{{ $t("barcode") }}</p>
              <p class="text-red-700 font-semibold">{{ item.item.i_barcode }}</p>
            </div>
          </div>

          <div
            class="flex px-5 py-4 bg-orange-100 items-center rounded-xl w-36 md:w-44 h-24 shadow-md hover:shadow-lg transition-all"
          >
            <i class="fa-solid fa-sack-dollar text-3xl text-orange-500"></i>
            <div class="w-4"></div>
            <div class="flex-col text-sm md:text-base">
              <p class="text-orange-500 font-medium mb-1">{{ $t("last_cost") }}</p>
              <p class="text-orange-500 font-semibold">
                {{ item.item.i_cost_price }}
                {{
                  filterItems[0] != null
                    ? $t(filterItems[0].currency.cur_name) != null
                      ? $t(filterItems[0].currency.cur_name)
                      : ""
                    : ""
                }}
              </p>
            </div>
          </div>

          <div
            class="flex px-5 py-4 bg-green-200 items-center rounded-xl w-36 md:w-44 h-24 shadow-md hover:shadow-lg transition-all"
          >
            <i
              class="fa-solid fa-money-check-dollar text-3xl text-green-700"
            ></i>
            <div class="w-4"></div>
            <div class="flex-col text-sm md:text-base">
              <p class="text-green-700 font-medium mb-1">{{ $t("sale_price") }}</p>
              <p class="text-green-700 font-semibold">
                {{ item.item.i_sale_price }}
                {{
                  $t(
                    item.item.currency != null
                      ? item.item.currency.cur_name
                      : ""
                  )
                }}
              </p>
            </div>
          </div>

          <div
            class="flex px-5 py-4 bg-indigo-200 items-center rounded-xl w-36 md:w-44 h-24 shadow-md hover:shadow-lg transition-all"
          >
            <i class="fa-solid fa-dollar text-3xl text-indigo-500"></i>
            <div class="w-4"></div>
            <div class="flex-col text-sm md:text-base">
              <p class="text-indigo-500 font-medium mb-1">
                {{ $t("sale_jwmla_price") }}
              </p>
              <p class="text-indigo-500 font-semibold">
                {{ item.item.i_sale_price_jwmla }}
                {{
                  $t(
                    item.item.currency != null
                      ? item.item.currency.cur_name
                      : ""
                  )
                }}
              </p>
            </div>
          </div>

          <div
            class="flex px-5 py-4 bg-purple-200 items-center rounded-xl w-36 md:w-44 h-24 shadow-md hover:shadow-lg transition-all"
          >
            <i class="fa-solid fa-weight-scale text-3xl text-purple-500"></i>
            <div class="w-4"></div>
            <div class="flex-col text-sm md:text-base">
              <p class="text-purple-600 font-medium mb-1">{{ $t("unit") }}</p>
              <p class="text-purple-600 font-semibold">
                {{ item.item.unit.un_name }}
              </p>
            </div>
          </div>
          <div
            class="flex px-5 py-4 bg-green-200 items-center rounded-xl w-36 md:w-44 h-24 shadow-md hover:shadow-lg transition-all"
          >
            <i class="fa-solid fa-dollar text-3xl text-green-500"></i>
            <div class="w-4"></div>
            <div class="flex-col text-sm md:text-sm">
              <p class="text-green-700 font-medium mb-1">
                {{ $t("dollar_price_in_bought_item_date") }}
              </p>
              <p class="text-green-700 font-semibold">
                {{ item.item.i_main_currency_price }} {{ $t("dinar") }}
              </p>
            </div>
          </div>

          <div
            class="flex px-5 py-4 bg-red-200 items-center rounded-xl w-36 md:w-44 h-24 shadow-md hover:shadow-lg transition-all"
          >
            <i class="fa-regular fa-calendar text-3xl text-red-700"></i>
            <div class="w-4"></div>
            <div class="flex-col text-sm md:text-base">
              <p class="text-red-700 font-medium mb-1">{{ $t("expire_date") }}</p>
              <p class="text-red-700 font-semibold">
                {{
                  item.item.i_expire_date != null
                    ? item.item.i_expire_date.toString().slice(0, 10)
                    : ""
                }}
              </p>
            </div>
          </div>

          <div
            class="flex px-5 py-4 bg-indigo-200 items-center rounded-xl w-36 md:w-44 h-24 shadow-md hover:shadow-lg transition-all"
          >
            <i class="fa-solid fa-box text-3xl text-indigo-700"></i>
            <div class="w-4"></div>
            <div class="flex-col text-sm md:text-base">
              <p class="text-indigo-700 font-medium mb-1">{{ $t("packages") }}</p>
              <p class="text-indigo-700 font-semibold">
                {{ item.item.i_packages ? item.item.i_packages.length : 0 }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Perfume Information Section -->
    <div v-if="item && item.item" class="mt-6">
      <h2 class="text-xl font-bold text-gray-900 dark:text-white mb-4 pb-2 border-b border-gray-200 dark:border-gray-700">
        {{ $t("perfume_information") || "Perfume Information" }}
      </h2>
      
      <!-- Gender, Brand, Longevity, Is Famous - Cards with Better Spacing -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div v-if="item.item.i_gender" class="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-md hover:shadow-lg transition-all duration-200">
          <div class="flex items-center space-x-6">
            <div class="p-3 bg-blue-100 dark:bg-blue-900 rounded-xl flex-shrink-0">
              <i 
                :class="{
                  'fa-solid fa-mars text-xl text-blue-600 dark:text-blue-400': item.item.i_gender === 'male',
                  'fa-solid fa-venus text-xl text-blue-600 dark:text-blue-400': item.item.i_gender === 'female',
                  'fa-solid fa-venus-mars text-xl text-blue-600 dark:text-blue-400': item.item.i_gender === 'both'
                }"
              ></i>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm text-gray-500 dark:text-gray-400 mb-1">{{ $t("item_gender") }}</p>
              <p class="text-base font-semibold text-gray-900 dark:text-white">
                {{ item.item.i_gender && ['male', 'female', 'both'].includes(item.item.i_gender) ? $t(item.item.i_gender) : item.item.i_gender || '—' }}
              </p>
            </div>
          </div>
        </div>

        <div v-if="item.item.brand" class="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-md hover:shadow-lg transition-all duration-200">
          <div class="flex items-center space-x-6">
            <div class="p-3 bg-blue-100 dark:bg-blue-900 rounded-xl flex-shrink-0">
              <i class="fa-solid fa-tag text-xl text-blue-600 dark:text-blue-400"></i>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm text-gray-500 dark:text-gray-400 mb-1">{{ $t("item_brand") }}</p>
              <p class="text-base font-semibold text-gray-900 dark:text-white truncate">
                {{ item.item.brand.br_name }}
              </p>
            </div>
            <img v-if="item.item.brand.br_image" :src="file_url + item.item.brand.br_image" class="w-12 h-12 rounded-lg object-cover border-2 border-gray-200 dark:border-gray-600 flex-shrink-0 shadow-sm ml-3" alt="Brand" />
          </div>
        </div>

        <div v-if="item.item.i_longevity" class="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-md hover:shadow-lg transition-all duration-200">
          <div class="flex items-center space-x-6">
            <div class="p-3 bg-orange-100 dark:bg-orange-900 rounded-xl flex-shrink-0">
              <i class="fa-solid fa-clock text-xl text-orange-600 dark:text-orange-400"></i>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm text-gray-500 dark:text-gray-400 mb-1">{{ $t("item_longevity") }}</p>
              <p class="text-base font-semibold text-gray-900 dark:text-white">
                {{ item.item.i_longevity }} {{ $t("hours") || "h" }}
              </p>
            </div>
          </div>
        </div>

        <!-- Is Famous Status Card -->
        <div class="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-md hover:shadow-lg transition-all duration-200">
          <div class="flex items-center space-x-6">
            <div class="p-3 rounded-xl flex-shrink-0" :class="item.item.i_is_famous == 1 ? 'bg-yellow-100 dark:bg-yellow-900' : 'bg-gray-100 dark:bg-gray-700'">
              <i 
                :class="item.item.i_is_famous == 1 ? 'fa-solid fa-star text-xl text-yellow-600 dark:text-yellow-400' : 'fa-regular fa-star text-xl text-gray-600 dark:text-gray-400'"
              ></i>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm text-gray-500 dark:text-gray-400 mb-1">{{ $t("is_famous") || "Is Famous" }}</p>
              <p 
                class="text-base font-semibold"
                :class="item.item.i_is_famous == 1 ? 'text-yellow-600 dark:text-yellow-400' : 'text-gray-600 dark:text-gray-400'"
              >
                {{ item.item.i_is_famous == 1 ? ($t("famous") || "Famous") : ($t("not_famous") || "Not Famous") }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Multiple Images Gallery - Cards with Better Spacing -->
      <div v-if="item.item.i_images && Array.isArray(item.item.i_images) && item.item.i_images.length > 0" class="mb-6">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
          <i class="fa-solid fa-images mr-3 text-blue-500"></i>
          {{ $t("item_images") }} ({{ item.item.i_images.length }})
        </h3>
        <div class="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          <div v-for="(imgPath, index) in item.item.i_images" :key="index" class="relative group cursor-pointer" @click="openImageModal(file_url + imgPath)">
            <img :src="file_url + imgPath" :alt="'Image ' + (index + 1)" class="w-full h-32 object-cover rounded-xl border-2 border-gray-200 dark:border-gray-700 hover:opacity-90 hover:border-blue-500 hover:shadow-lg transition-all duration-200 shadow-md" />
            <div class="absolute top-2 right-2 bg-black bg-opacity-75 text-white px-2 py-1 rounded-full text-xs font-semibold shadow-lg pointer-events-none">
              {{ index + 1 }}
            </div>
            <div class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all rounded-xl flex items-center justify-center pointer-events-none">
              <i class="fa-solid fa-expand text-white text-xl opacity-0 group-hover:opacity-100 transition-opacity"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Sizes Section - Cards with Better Spacing -->
      <div v-if="item.item.i_sizes && Array.isArray(item.item.i_sizes) && item.item.i_sizes.length > 0" class="mb-6">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
          <i class="fa-solid fa-ruler-combined mr-3 text-green-500"></i>
          {{ $t("item_sizes") }} ({{ item.item.i_sizes.length }})
        </h3>
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div v-for="(size, index) in item.item.i_sizes" :key="index" class="bg-white dark:bg-gray-800 rounded-xl p-4 border border-gray-200 dark:border-gray-700 shadow-md hover:shadow-lg transition-all duration-200">
            <div class="flex items-center justify-between">
              <div class="flex items-center space-x-7">
                <div class="p-2 bg-green-100 dark:bg-green-900 rounded-lg flex-shrink-0">
                  <i class="fa-solid fa-flask text-green-600 dark:text-green-400"></i>
                </div>
                <div>
                  <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">{{ $t("size") }}</p>
                  <p class="text-sm font-bold text-gray-900 dark:text-white">{{ size.is_size }}</p>
                </div>
              </div>
              <div class="text-right">
                <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">{{ $t("price") }}</p>
                <p class="text-sm font-bold text-green-600 dark:text-green-400">
                  {{ formatNumber(size.is_price) }}
                  <span class="text-xs ml-1">{{ item.item.currency ? $t(item.item.currency.cur_name) : '' }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Seasons Section - Cards with Better Spacing -->
      <div v-if="item.item.i_seasons && Array.isArray(item.item.i_seasons) && item.item.i_seasons.length > 0" class="mb-6">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
          <i class="fa-solid fa-calendar-days mr-3 text-purple-500"></i>
          {{ $t("item_seasons") }} ({{ item.item.i_seasons.length }})
        </h3>
        <div class="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-md">
          <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div v-for="(season, index) in item.item.i_seasons" :key="index" class="relative">
              <div class="flex flex-col items-center justify-between p-4 bg-gradient-to-br from-gray-50 to-white dark:from-gray-700 dark:to-gray-800 rounded-xl border border-gray-200 dark:border-gray-600 shadow-sm hover:shadow-md transition-all">
                <div class="flex items-center space-x-3 w-full mb-3">
                  <i :class="getSeasonIcon(season.ise_season)" class="text-2xl flex-shrink-0"></i>
                  <div class="flex-1 min-w-0 text-center">
                    <span class="font-semibold text-gray-900 dark:text-white block text-sm mb-1">
                      {{ season.ise_season && ['spring', 'winter', 'summer', 'autumn'].includes(season.ise_season) ? $t(season.ise_season) : season.ise_season || '—' }}
                    </span>
                    <span class="text-lg font-bold text-blue-600 dark:text-blue-400">{{ season.ise_percentage }}%</span>
                  </div>
                </div>
                <div class="w-full h-3 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden shadow-inner">
                  <div class="h-full bg-gradient-to-r from-blue-400 to-blue-600 rounded-full transition-all duration-500" :style="{ width: season.ise_percentage + '%' }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Use Time Section - Cards with Better Spacing -->
      <div v-if="item.item.i_use_times && Array.isArray(item.item.i_use_times) && item.item.i_use_times.length > 0" class="mb-6">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
          <i class="fa-solid fa-clock-rotate-left mr-3 text-yellow-500"></i>
          {{ $t("item_use_time") }} ({{ item.item.i_use_times.length }})
        </h3>
        <div class="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-md">
          <div class="flex items-center justify-between gap-4">
            <div v-for="(useTime, index) in item.item.i_use_times" :key="index" class="flex-1 text-center">
              <div class="flex flex-col items-center space-y-3 p-4 bg-gradient-to-br from-gray-50 to-white dark:from-gray-700 dark:to-gray-800 rounded-xl border border-gray-200 dark:border-gray-600 shadow-sm hover:shadow-md transition-all">
                <i :class="useTime.iut_type === 'day' ? 'fa-solid fa-sun text-3xl text-yellow-500' : 'fa-solid fa-moon text-3xl text-indigo-500'"></i>
                <span class="font-semibold text-base text-gray-900 dark:text-white">
                  {{ useTime.iut_type && ['day', 'night'].includes(useTime.iut_type) ? $t(useTime.iut_type) : useTime.iut_type || '—' }}
                </span>
                <span class="text-xl font-bold" :class="useTime.iut_type === 'day' ? 'text-yellow-600 dark:text-yellow-400' : 'text-indigo-600 dark:text-indigo-400'">{{ useTime.iut_percentage }}%</span>
              </div>
              <div class="mt-3 h-3 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden mx-auto shadow-inner" style="width: 80%;">
                <div class="h-full rounded-full transition-all duration-500" :class="useTime.iut_type === 'day' ? 'bg-gradient-to-r from-yellow-400 to-yellow-600' : 'bg-gradient-to-r from-indigo-400 to-indigo-600'" :style="{ width: useTime.iut_percentage + '%' }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Accords Notes Section - Cards with Better Spacing -->
      <div v-if="item.item.i_accord_notes && Array.isArray(item.item.i_accord_notes) && item.item.i_accord_notes.length > 0" class="mb-6">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
          <i class="fa-solid fa-music mr-3 text-pink-500"></i>
          {{ $t("item_main_accords_notes") }} ({{ item.item.i_accord_notes.length }})
        </h3>
        <div class="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-md">
          <div class="space-y-4">
            <div v-for="(accordNote, index) in item.item.i_accord_notes" :key="index" class="flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-white dark:from-gray-700 dark:to-gray-800 rounded-xl border border-gray-200 dark:border-gray-600 hover:shadow-md transition-all duration-200">
              <div class="flex items-center space-x-4 flex-1 min-w-0">
                <div v-if="accordNote.accordsNote && accordNote.accordsNote.an_image" class="w-14 h-14 rounded-lg overflow-hidden border-2 border-gray-200 dark:border-gray-600 flex-shrink-0 shadow-sm">
                  <img :src="file_url + accordNote.accordsNote.an_image" :alt="accordNote.accordsNote.an_name" class="w-full h-full object-cover" />
                </div>
                <div v-else class="w-14 h-14 rounded-lg flex items-center justify-center border-2 border-gray-200 dark:border-gray-600 flex-shrink-0 shadow-sm" :style="{ backgroundColor: (accordNote.accordsNote && accordNote.accordsNote.an_color) || '#3B82F6' }">
                  <i class="fa-solid fa-music text-white text-lg"></i>
                </div>
                <div class="flex-1 min-w-0">
                  <p class="font-semibold text-base text-gray-900 dark:text-white mb-2 truncate">
                    {{ accordNote.accordsNote ? accordNote.accordsNote.an_name : 'Note #' + (index + 1) }}
                  </p>
                  <div class="h-3 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden shadow-inner">
                    <div class="h-full rounded-full transition-all duration-500" :style="{ 
                      width: accordNote.ian_percentage + '%',
                      backgroundColor: (accordNote.accordsNote && accordNote.accordsNote.an_color) || '#3B82F6'
                    }"></div>
                  </div>
                </div>
                <div class="text-right min-w-[60px] flex-shrink-0">
                  <span class="text-lg font-bold" :style="{ color: (accordNote.accordsNote && accordNote.accordsNote.an_color) || '#3B82F6' }">
                    {{ accordNote.ian_percentage }}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button
      class="mx-2 my_font bg-primaryColor hover:bg-blue-700 text-white font-bold py-1 px-4 rounded no-print"
      @click="printReportFunc"
      id="button_print"
    >
      {{ $t("print") }}
    </button>
    <button
      class="mx-2 my_font bg-green-500 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded no-print"
      @click="showModal()"
      id="button_print"
    >
      {{ $t("edit") }}
    </button>
    <div v-if="isHide">
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
    <!-- Package Information Section -->
    <div v-if="item.item.i_packages && item.item.i_packages.length > 0" class="mt-12">
      <p class="font-semibold text-xl text-textBlack dark:text-textWhite mb-4">
        {{ $t("package_info") }}
      </p>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div
          v-for="(pkg, index) in item.item.i_packages"
          :key="index"
          class="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700"
        >
          <div class="flex items-center justify-between mb-2">
            <h4 class="font-semibold text-gray-900 dark:text-white">
              {{ pkg.name || $t("package") + " " + (index + 1) }}
            </h4>
            <span class="text-sm text-gray-500 dark:text-gray-400">
              {{ pkg.quantity }}+ {{ $t("items") }}
            </span>
          </div>
          <p class="text-lg font-bold text-blue-600 dark:text-blue-400">
            {{ formatNumber(pkg.price) }} {{ $t(item.item.currency ? item.item.currency.cur_name : "dinar") }}
          </p>
        </div>
      </div>
    </div>

    <p class="font-semibold text-xl text-textBlack dark:text-textWhite mt-12">
      {{ $t("sale_detail") }}
    </p>

    <div
      class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 mt-4 mb-6 gap-x-4 gap-y-8"
    >
      <div
        class="bg-gray-700 bg-gradient-to-br from-gray-400 to-transparent border-b-2 border-r-2 border-white dark:border-gray-600 flex flex-col justify-between rounded-xl h-32 items-start px-4 py-3 shadow-lg"
      >
        <div class="flex justify-between w-full">
          <p class="text-white text-2xl">{{ item.item.i_in_quantity }}</p>
          <i class="fa-solid fa-sack-dollar text-2xl text-white"></i>
        </div>
        <p class="text-gray-300 text-sm py-1">
          {{ $t("item_bought_quantity_till_now") }}
        </p>
      </div>

      <div
        class="bg-purple-900 bg-gradient-to-br from-purple-400 to-transparent border-b-2 border-r-2 border-white dark:border-gray-600 flex flex-col justify-between rounded-xl h-32 items-start px-4 py-3 shadow-lg"
      >
        <div class="flex justify-between w-full">
          <p class="text-white text-2xl">{{ item.item.i_out_quantity }}</p>
          <i class="fa-solid fa-money-bill-trend-up text-2xl text-white"></i>
        </div>
        <p class="text-gray-300 text-sm py-1">
          {{ $t("item_sold_quantity_till_now") }}
        </p>
      </div>

      <div
        class="bg-blue-900 bg-gradient-to-br from-primaryColor to-transparent border-b-2 border-r-2 border-white dark:border-gray-600 flex flex-col justify-between rounded-xl h-32 items-start px-4 py-3 shadow-lg"
      >
        <div class="flex justify-between w-full">
          <p class="text-white text-2xl">{{ item.item.i_quantity }}</p>
          <i class="fa-solid fa-tag text-2xl text-white"></i>
        </div>

        <p class="text-gray-300 text-sm py-1">
          {{ $t("item_quantity_in_storage") }}
        </p>
      </div>
      <div
        class="bg-red-900 bg-gradient-to-br from-red-400 to-transparent border-b-2 border-r-2 border-white dark:border-gray-600 flex flex-col justify-between rounded-xl h-32 items-start px-4 py-3 shadow-lg"
      >
        <div class="flex justify-between w-full">
          <p class="text-white text-2xl">
            {{
              formatNumber(
                item.result_wasted.length > 0
                  ? item.result_wasted[0].total_waste_quantity
                  : 0
              )
            }}
          </p>
          <i class="fa-solid fa-arrow-trend-down text-2xl text-white"></i>
        </div>

        <p class="text-gray-300 text-sm py-1">
          {{ $t("total_wasted_quantity_in_this_period") }}
        </p>
      </div>
      <div
        class="bg-red-600 bg-gradient-to-br from-red-300 to-transparent border-b-2 border-r-2 border-white dark:border-gray-600 flex flex-col justify-between rounded-xl h-32 items-start px-4 py-3 shadow-lg"
      >
        <div class="flex justify-between w-full">
          <div class="">
            <p class="text-white text-2xl">
              {{
                formatNumber(
                  item.result_wasted.length > 0
                    ? item.result_wasted[0].total_cost_price_dollar
                    : 0
                )
              }}
              <i class="fa-solid fa-dollar-sign text-white text-xl"></i>
            </p>
            <p class="text-white text-2xl">
              {{
                formatNumber(
                  item.result_wasted.length > 0
                    ? item.result_wasted[0].total_cost_price_dinar
                    : 0
                )
              }}
              {{ $t("dinar") }}
            </p>
          </div>
          <i class="fa-solid fa-arrow-trend-down text-2xl text-white"></i>
        </div>
        <p class="text-gray-300 text-sm py-1">
          {{ $t("total_loss_of_wasted_item_in_this_period") }}
        </p>
      </div>

      <div
        class="bg-red-900 bg-gradient-to-br from-red-400 to-transparent border-b-2 border-r-2 border-white dark:border-gray-600 flex flex-col justify-between rounded-xl h-32 items-start px-4 py-3 shadow-lg"
      >
        <div class="flex justify-between w-full">
          <div class="">
            <p class="text-white text-2xl">
              {{ formatNumber(item.cost["2"]) }}
              <i class="fa-solid fa-dollar-sign text-white text-xl"></i>
            </p>
            <p class="text-white text-2xl">
              {{ formatNumber(item.cost["1"]) }}
              {{ $t("dinar") }}
            </p>
          </div>
          <i class="fa-solid fa-store text-2xl text-white"></i>
        </div>

        <p class="text-gray-300 text-sm py-1">
          {{ $t("total_cost") }} {{ $t("item_quantity_in_storage") }}
        </p>
      </div>

      <div
        class="bg-yellow-900 bg-gradient-to-br from-yellow-400 to-transparent border-b-2 border-r-2 border-white dark:border-gray-600 flex flex-col justify-between rounded-xl h-32 items-start px-4 py-3 shadow-lg"
      >
        <div class="flex justify-between w-full">
          <p class="text-white text-2xl">
            {{ formatNumber(item.item.total_sale_price_current_koga) }}
            {{
              $t(item.item.currency != null ? item.item.currency.cur_name : "")
            }}
          </p>
          <i class="fa-solid fa-store text-2xl text-white"></i>
        </div>
        <p class="text-gray-300 text-sm py-1">
          {{ $t("total_sale") }} {{ $t("item_quantity_in_storage") }}
          {{ $t("sale_tak") }}
        </p>
      </div>

      <div
        class="bg-green-900 bg-gradient-to-br from-green-400 to-transparent border-b-2 border-r-2 border-white dark:border-gray-600 flex flex-col justify-between rounded-xl h-32 items-start px-4 py-3 shadow-lg"
      >
        <div class="flex justify-between w-full">
          <p class="text-white text-2xl">
            {{
              formatNumber(
                item.item.total_sale_price_current_koga - item.remainingCost
              )
            }}
            {{
              $t(item.item.currency != null ? item.item.currency.cur_name : "")
            }}
          </p>
          <i class="fa-solid fa-coins text-2xl text-white"></i>
        </div>
        <p class="text-gray-300 text-sm py-1">
          {{ $t("total_profit") }} {{ $t("item_quantity_in_storage") }}
          {{ $t("sale_tak") }}
        </p>
      </div>
      <div
        class="bg-purple-900 bg-gradient-to-br from-purple-400 to-transparent border-b-2 border-r-2 border-white dark:border-gray-600 flex flex-col justify-between rounded-xl h-32 items-start px-4 py-3 shadow-lg"
      >
        <div class="flex justify-between w-full">
          <p class="text-white text-2xl">
            {{
              formatNumber(
                item.result.length > 0 ? item.result[0].item_quantity_sold : 0
              )
            }}
          </p>
          <i class="fa-solid fa-money-bill-trend-up text-2xl text-white"></i>
        </div>
        <p class="text-gray-300 text-sm py-1">
          {{ $t("sold_item_in_this_period") }}
        </p>
      </div>
      <div
        class="bg-red-600 bg-gradient-to-br from-red-300 to-transparent border-b-2 border-r-2 border-white dark:border-gray-600 flex flex-col justify-between rounded-xl h-32 items-start px-4 py-3 shadow-lg"
      >
        <div class="flex justify-between w-full">
          <div class="">
            <p class="text-white text-2xl">
              {{
                formatNumber(
                  item.result.length > 0
                    ? item.result[0].total_cost_price_dollar
                    : 0
                )
              }}
              <i class="fa-solid fa-dollar-sign text-white text-xl"></i>
            </p>
            <p class="text-white text-2xl">
              {{
                formatNumber(
                  item.result.length > 0
                    ? item.result[0].total_cost_price_dinar
                    : 0
                )
              }}
              {{ $t("dinar") }}
            </p>
          </div>
          <i class="fa-solid fa-cart-shopping text-2xl text-white"></i>
        </div>
        <p class="text-gray-300 text-sm py-1">
          {{ $t("total_cost_of_sale_item_in_this_period") }}
        </p>
      </div>
      <div
        class="bg-yellow-600 bg-gradient-to-br from-yellow-300 to-transparent border-b-2 border-r-2 border-white dark:border-gray-600 flex flex-col justify-between rounded-xl h-32 items-start px-4 py-3 shadow-lg"
      >
        <div class="flex justify-between w-full">
          <div class="">
            <p class="text-white text-2xl">
              {{
                formatNumber(
                  item.result.length > 0
                    ? item.result[0].total_sale_price_dollar
                    : 0
                )
              }}
              <i class="fa-solid fa-dollar-sign text-white text-xl"></i>
            </p>
            <p class="text-white text-2xl">
              {{
                formatNumber(
                  item.result.length > 0
                    ? item.result[0].total_sale_price_dinar
                    : 0
                )
              }}
              {{ $t("dinar") }}
            </p>
          </div>
          <i class="fa-solid fa-store text-2xl text-white"></i>
        </div>
        <p class="text-gray-300 text-sm py-1">
          {{ $t("total_item_sale_in_this_period") }}
        </p>
      </div>

      <div
        class="bg-green-600 bg-gradient-to-br from-green-300 to-transparent border-b-2 border-r-2 border-white dark:border-gray-600 flex flex-col justify-between rounded-xl h-32 items-start px-4 py-3 shadow-lg"
      >
        <div class="flex justify-between w-full">
          <div class="">
            <p class="text-white text-2xl">
              {{
                formatNumber(
                  item.result.length > 0
                    ? item.result[0].total_profit_dollar
                    : 0
                )
              }}
              <i class="fa-solid fa-dollar-sign text-white text-xl"></i>
            </p>
            <p class="text-white text-2xl">
              {{
                formatNumber(
                  item.result.length > 0 ? item.result[0].total_profit_dinar : 0
                )
              }}
              {{ $t("dinar") }}
            </p>
          </div>
          <i class="fa-solid fa-coins text-2xl text-white"></i>
        </div>
        <p class="text-gray-300 text-sm py-1">
          {{ $t("total_profit_of_sale_item_in_this_period") }}
        </p>
      </div>
      <div
        class="bg-gray-700 bg-gradient-to-br from-gray-400 to-transparent border-b-2 border-r-2 border-white dark:border-gray-600 flex flex-col justify-between rounded-xl h-32 items-start px-4 py-3 shadow-lg"
      >
        <div class="flex justify-between w-full">
          <div class="">
            <p class="text-white text-2xl">
              {{
                formatNumber(
                  item.result.length > 0
                    ? item.result[0].total_discount_dollar
                    : 0
                )
              }}
              <i class="fa-solid fa-dollar-sign text-white text-xl"></i>
            </p>
            <p class="text-white text-2xl">
              {{
                formatNumber(
                  item.result.length > 0
                    ? item.result[0].total_discount_dinar
                    : 0
                )
              }}
              {{ $t("dinar") }}
            </p>
          </div>
          <i class="fa-solid fa-arrow-trend-down text-2xl text-white"></i>
        </div>
        <p class="text-gray-300 text-sm py-1">
          {{ $t("total_discount_of_sale_item_in_this_period") }}
        </p>
      </div>
    </div>

    <p class="font-semibold text-xl text-textBlack dark:text-textWhite mt-12">
      {{ $t("purchases") }}
    </p>
    <br />
    <EasyDataTable
      :headers="headers"
      :items="filterItems"
      :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
      alternating
      :header-props="{ 'sort-icon': 'fa-solid fa-arrow-up-wide-short' }"
      :loading="isLoadingData"
      :class="isDark ? 'customize-table ' : 'light-mode-table'"
    >
      <template #default="{ column, sortDirection }">
        <span class="custom-sort-icon" v-if="column.sortable">
          <i
            v-if="sortDirection === 'asc'"
            class="fa-solid fa-arrow-up-wide-short"
          ></i>
          <i
            v-else-if="sortDirection === 'desc'"
            class="fa-solid fa-arrow-up-wide-short"
          ></i>
          <i v-else class="fa-solid fa-arrow-up-wide-short"></i>
        </span>
        {{ column.label }}
      </template>

      <template #loading>
        <img
          src="../../assets/loading.webp"
          style="width: 70px; height: 70px"
        />
      </template>
      <template #item-total_cost="item">
        {{
          formatNumber(
            (item.pui_quantity - item.pui_out_quantity) * item.pui_cost_price
          )
        }} </template
      ><template #item-pui_cost_price="item">
        {{ formatNumber(item.pui_cost_price) }}
      </template>
      <template #item-remaining_quantity="item">
        {{ formatNumber(item.pui_quantity - item.pui_out_quantity) }} </template
      ><template #item-currency_cur_name="item">
        {{ $t(item.currency.cur_name) }}
      </template>
      <template #item-created_at="item">
        {{ formatDate(item.created_at) }} </template
      ><template #empty-message>
        <span class="text-textBlack1 dark:text-white">
          {{ $t("no_data_found") }}
        </span>
      </template>
      <template #pagination="{ prevPage, nextPage, isFirstPage, isLastPage }">
        <button :disabled="isFirstPage" @click="prevPage">
          <i
            :class="
              'fa-sharp fa-solid ' +
              ($store.getters['isRtl']
                ? ' fa-chevron-right'
                : ' fa-chevron-left')
            "
          ></i>
        </button>
        <div class="w-5"></div>
        <button :disabled="isLastPage" @click="nextPage">
          <i
            :class="
              'fa-sharp fa-solid ' +
              ($store.getters['isRtl']
                ? ' fa-chevron-left'
                : ' fa-chevron-right')
            "
          ></i>
        </button>
      </template>
    </EasyDataTable>
    <br />
    <br />

    <p class="font-semibold text-xl text-textBlack dark:text-textWhite mt-12">
      {{ $t("sales") }}
    </p>
    <br />
    <EasyDataTable
      :headers="headersSales"
      :items="filterItemsSold"
      :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
      alternating
      :header-props="{ 'sort-icon': 'fa-solid fa-arrow-up-wide-short' }"
      :loading="isLoadingData"
      :class="isDark ? 'customize-table ' : 'light-mode-table'"
    >
      <template #default="{ column, sortDirection }">
        <span class="custom-sort-icon" v-if="column.sortable">
          <i
            v-if="sortDirection === 'asc'"
            class="fa-solid fa-arrow-up-wide-short"
          ></i>
          <i
            v-else-if="sortDirection === 'desc'"
            class="fa-solid fa-arrow-up-wide-short"
          ></i>
          <i v-else class="fa-solid fa-arrow-up-wide-short"></i>
        </span>
        {{ column.label }}
      </template>

      <template #loading>
        <img
          src="../../assets/loading.webp"
          style="width: 70px; height: 70px"
        />
      </template>
      <template #item-in_id="item">
        {{ item.in_id }}
      </template>
      <template #[`item-invoice.customer.su_name`]="item">
        {{ item.invoice?.customer?.su_name || "-" }}
      </template>
      <template #item-si_quantity="item">
        {{ formatNumber(item.si_quantity) }}
      </template>
      <template #item-si_cost_price="item">
        {{ formatNumber(item.si_cost_price) + " " + $t(item.currency_name) }}
      </template>
      <template #item-si_sale_price="item">
        {{ formatNumber(item.si_sale_price) + " " + $t(item.currency_name) }}
      </template>
      <template #item-si_discount="item">
        {{ formatNumber(item.si_discount) + " " + $t(item.currency_name) }}
      </template>
      <template #item-si_profit="item">
        {{
          formatNumber(
            (item.si_sale_price - item.si_cost_price) * item.si_quantity -
              item.si_discount
          ) +
          " " +
          $t(item.currency_name)
        }}
      </template>
      <template #item-si_type="item">
        <span v-show="item.si_type == 1"> {{ $t("sale_tak") }} </span>
        <span v-show="item.si_type == 2"> {{ $t("sale_jwmla") }} </span>
      </template>
      <template #item-created_at="item">
        {{ formatDate(item.created_at) }}
      </template>
      <template #[`item-purchase.users.name`]="item">
        {{ item.purchase?.users?.name || "-" }}
      </template>
      <template #empty-message>
        <span class="text-textBlack1 dark:text-white">
          {{ $t("no_data_found") }}
        </span>
      </template>
      <template #pagination="{ prevPage, nextPage, isFirstPage, isLastPage }">
        <button :disabled="isFirstPage" @click="prevPage">
          <i
            :class="
              'fa-sharp fa-solid ' +
              ($store.getters['isRtl']
                ? ' fa-chevron-right'
                : ' fa-chevron-left')
            "
          ></i>
        </button>
        <div class="w-5"></div>
        <button :disabled="isLastPage" @click="nextPage">
          <i
            :class="
              'fa-sharp fa-solid ' +
              ($store.getters['isRtl']
                ? ' fa-chevron-left'
                : ' fa-chevron-right')
            "
          ></i>
        </button>
      </template>
    </EasyDataTable>
  </div>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit="editItem">
        <BaseInput
          v-model="current.i_name"
          :label="$t('item_name')"
          :placeholder="$t('item_name')"
          :rules="rules"
          :isError="
            checkRulesIsError(current.i_name, 'add', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.i_name, 'add', this.rules).errorMsg
          "
        /><DropdownInput
          v-model="current.ca_id"
          :placeholder="$t('choose_item_category')"
          :label="$t('item_category')"
          :items="convertToListIdValueCategory"
          :rules="rules_dropdown"
          :isError="
            checkRulesIsError(current.ca_id, 'add', this.rules_dropdown).isError
          "
          :errorMsg="
            checkRulesIsError(current.ca_id, 'add', this.rules_dropdown)
              .errorMsg
          "
        /><DropdownInput
          v-model="current.un_id"
          :label="$t('item_unit')"
          :items="convertToListIdValueUnits"
          :placeholder="$t('choose_item_unit')"
          :rules="rules_dropdown"
          :isError="
            checkRulesIsError(current.un_id, 'add', this.rules_dropdown).isError
          "
          :errorMsg="
            checkRulesIsError(current.un_id, 'add', this.rules_dropdown)
              .errorMsg
          "
        />
        <!-- 
        <div>
          <label
            for="saleType"
            class="block mb-2 text-base font-medium text-textBlack1 dark:text-textWhite1"
            >{{ $t("suplier") }}</label
          >
          <VueMultiselect
            v-model="current.su_id"
            :options="convertToListIdValueSupliers"
            :multiple="false"
            :placeholder="$t('choose_suplier')"
            label="value"
            track-by="id"
            :taggable="true"
          >
          </VueMultiselect>
        </div>-->
        <DropdownInput
          v-model="current.cur_id"
          :label="$t('currency_type')"
          :items="convertToListIdValue"
          :placeholder="$t('choose_currency_type')"
          :rules="rules_dropdown"
          :isError="
            checkRulesIsError(current.cur_id, 'add', this.rules_dropdown)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.cur_id, 'add', this.rules_dropdown)
              .errorMsg
          "
        />
        <BaseInput
          v-model="current.i_sale_price"
          :label="$t('sale_item_price')"
          :placeholder="$t('sale_item_price')"
          :rules="rules"
          type="number"
          :isError="
            checkRulesIsError(current.i_sale_price, 'add', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.i_sale_price, 'add', this.rules).errorMsg
          "
        />
        <BaseInput
          v-model="current.i_sale_price_jwmla"
          :label="$t('sale_jwmla_price')"
          :placeholder="$t('sale_jwmla_price')"
          type="number"
        />

        <BaseInput
          v-model="current.i_main_currency_price"
          :label="$t('dolar_price_in_bought_item_date')"
          :placeholder="$t('dolar_price_in_bought_item_date')"
          :rules="rules"
          type="number"
          :isError="
            checkRulesIsError(current.i_main_currency_price, 'add', this.rules)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.i_main_currency_price, 'add', this.rules)
              .errorMsg
          "
        />
        <BaseInput
          v-model="current.i_expire_date"
          type="date"
          :label="$t('expire_Date')"
          :placeholder="$t('write_expire_date_if_has')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.i_expire_date, 'add', this.no_rule)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.i_expire_date, 'add', this.no_rule)
              .errorMsg
          "
        />

        <TextAreaInput
          v-model="current.i_desc"
          :label="$t('item_description')"
          :placeholder="$t('item_description')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.i_desc, 'add', this.no_rule).isError
          "
          :errorMsg="
            checkRulesIsError(current.i_desc, 'add', this.no_rule).errorMsg
          "
        />

        <!-- Perfume Fields -->
        <div class="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            {{ $t("perfume_information") || "Perfume Information" }}
          </h3>
          
          <DropdownInput
            v-model="current.i_gender"
            :label="$t('item_gender')"
            :items="genderOptions"
            :placeholder="$t('choose_gender')"
            :rules="no_rule"
          />
          
          <DropdownInput
            v-model="current.br_id"
            :label="$t('item_brand')"
            :items="convertToListIdValueBrands"
            :placeholder="$t('choose_brand')"
            :rules="no_rule"
          />
          
          <BaseInput
            v-model="current.i_longevity"
            type="number"
            :label="$t('item_longevity')"
            :placeholder="$t('longevity_hours')"
            :rules="no_rule"
          />

          <!-- Is Famous Checkbox -->
          <div class="mb-4">
            <label class="flex items-center space-x-2 cursor-pointer">
              <input
                type="checkbox"
                v-model="current.i_is_famous"
                :true-value="1"
                :false-value="0"
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <span class="text-base font-medium text-textBlack1 dark:text-textWhite1">
                {{ $t("is_famous") || "Is Famous" }}
              </span>
            </label>
          </div>

          <!-- Multiple Images -->
          <div class="mb-4">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              {{ $t("item_images") }}
            </label>
            <div class="space-y-2">
              <div v-for="(img, index) in item_images" :key="index" class="flex items-center space-x-2 p-2 bg-gray-50 dark:bg-gray-700 rounded">
                <img v-if="img.preview" :src="img.preview" class="w-16 h-16 object-cover rounded border flex-shrink-0" />
                <div class="flex-1">
                  <FileInput
                    :modelValue="img.file"
                    @update:modelValue="updateImageFile(index, $event)"
                    :label="''"
                    :placeholder="$t('choose_image')"
                    :rules="no_rule"
                  />
                </div>
                <button
                  type="button"
                  @click="removeImage(index)"
                  class="px-3 py-2 bg-red-500 text-white rounded hover:bg-red-600 flex-shrink-0"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
              <button
                type="button"
                @click="addImage"
                class="w-full px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                <i class="fa-solid fa-plus mr-2"></i>
                {{ $t("add_image") }}
              </button>
            </div>
          </div>

          <!-- Sizes -->
          <div class="mb-4">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              {{ $t("item_sizes") }}
            </label>
            <div class="space-y-2">
              <div v-for="(size, index) in item_sizes" :key="index" class="flex items-center space-x-2">
                <BaseInput
                  v-model="size.is_size"
                  :label="$t('size')"
                  :placeholder="$t('size')"
                  :rules="no_rule"
                  class="flex-1"
                />
                <BaseInput
                  v-model="size.is_price"
                  type="number"
                  :label="$t('price')"
                  :placeholder="$t('price')"
                  :rules="no_rule"
                  class="flex-1"
                />
                <BaseInput
                  v-model="size.is_discount"
                  type="number"
                  :label="$t('discount')"
                  :placeholder="$t('discount')"
                  :rules="no_rule"
                  class="flex-1"
                />
                <button
                  type="button"
                  @click="removeSize(index)"
                  class="px-3 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
              <button
                type="button"
                @click="addSize"
                class="w-full px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                <i class="fa-solid fa-plus mr-2"></i>
                {{ $t("add_size") }}
              </button>
            </div>
          </div>

          <!-- Seasons -->
          <div class="mb-4">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              {{ $t("item_seasons") }}
            </label>
            <div class="space-y-2">
              <div v-for="(season, index) in item_seasons" :key="index" class="flex items-center space-x-2">
                <DropdownInput
                  v-model="season.ise_season"
                  :label="$t('season')"
                  :items="seasonOptions"
                  :placeholder="$t('choose_season')"
                  :rules="no_rule"
                  class="flex-1"
                />
                <BaseInput
                  v-model="season.ise_percentage"
                  type="number"
                  :label="$t('season_percentage')"
                  :placeholder="$t('percentage')"
                  :rules="no_rule"
                  class="flex-1"
                />
                <button
                  type="button"
                  @click="removeSeason(index)"
                  class="px-3 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
              <button
                type="button"
                @click="addSeason"
                class="w-full px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                <i class="fa-solid fa-plus mr-2"></i>
                {{ $t("add_season") }}
              </button>
            </div>
          </div>

          <!-- Use Times -->
          <div class="mb-4">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              {{ $t("item_use_time") }}
            </label>
            <div class="space-y-2">
              <div v-for="(useTime, index) in item_use_times" :key="index" class="flex items-center space-x-2">
                <DropdownInput
                  v-model="useTime.iut_type"
                  :label="$t('use_time_type')"
                  :items="useTimeOptions"
                  :placeholder="$t('choose_use_time_type')"
                  :rules="no_rule"
                  class="flex-1"
                />
                <BaseInput
                  v-model="useTime.iut_percentage"
                  type="number"
                  :label="$t('use_time_percentage')"
                  :placeholder="$t('percentage')"
                  :rules="no_rule"
                  class="flex-1"
                />
                <button
                  type="button"
                  @click="removeUseTime(index)"
                  class="px-3 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
              <button
                type="button"
                @click="addUseTime"
                class="w-full px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                <i class="fa-solid fa-plus mr-2"></i>
                {{ $t("add_use_time") }}
              </button>
            </div>
          </div>

          <!-- Accord Notes -->
          <div class="mb-4">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              {{ $t("item_main_accords_notes") }}
            </label>
            <div class="space-y-2">
              <div v-for="(accordNote, index) in item_accord_notes" :key="index" class="flex items-center space-x-2">
                <DropdownInput
                  v-model="accordNote.an_id"
                  :label="$t('accord_note')"
                  :items="convertToListIdValueAccordsNotes"
                  :placeholder="$t('choose_accord_note')"
                  :rules="no_rule"
                  class="flex-1"
                />
                <BaseInput
                  v-model="accordNote.ian_percentage"
                  type="number"
                  :label="$t('accord_note_percentage')"
                  :placeholder="$t('percentage')"
                  :rules="no_rule"
                  class="flex-1"
                />
                <button
                  type="button"
                  @click="removeAccordNote(index)"
                  class="px-3 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
              <button
                type="button"
                @click="addAccordNote"
                class="w-full px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                <i class="fa-solid fa-plus mr-2"></i>
                {{ $t("add_accord_note") }}
              </button>
            </div>
          </div>
        </div>

        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div>
  </edit-modal>
  <image-modal ref="imageModal"></image-modal>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import LoadingProgress from "../../components/loading-progress.vue";
import { formatDate } from "../../utils/functions";
import { formatNumber } from "../../utils/functions";
import moment from "moment";
import { FILE_URL } from "../../constants/config";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import EditModal from "../../components/Modals/EditModal.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import { CURRENCYS } from "../../constants/config";
import ImageModal from "../../components/Modals/ImageModal2.vue";
import FileInput from "../../components/Inputs/FileInput.vue";

export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    LoadingProgress,
    InvoiceHeader,
    EditModal,
    BaseInput,
    ButtonInput,
    DropdownInput,
    TextAreaInput,
    FileInput,
    ImageModal,
  },
  data() {
    return {
      firstName: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      no_rule: [],
      su_name: "",
      su_note: "",
      su_phone: "",
      su_address: "",
      su_email: "",
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      ci_id: "",
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      file_url: FILE_URL,
      su_image: "",
      startDate: "",
      endDate: "",
      period: "last30days",
      items: null,
      invoiceType: "0",
      isHide: false,
      currencys: CURRENCYS,
      accordNotesMap: {}, // Cache for accord notes data
      // Perfume fields for edit
      item_images: [],
      item_sizes: [],
      item_seasons: [],
      item_use_times: [],
      item_accord_notes: [],
      genderOptions: [
        { id: "male", value: "male" },
        { id: "female", value: "female" },
        { id: "both", value: "both" },
      ],
      seasonOptions: [
        { id: "spring", value: "spring" },
        { id: "winter", value: "winter" },
        { id: "summer", value: "summer" },
        { id: "autumn", value: "autumn" },
      ],
      useTimeOptions: [
        { id: "day", value: "day" },
        { id: "night", value: "night" },
      ],
    };
  },
  created() {
    this.startDate = moment().subtract(30, "days").format("YYYY-MM-DD");
    this.endDate = moment().format("YYYY-MM-DD");
    this.getData();
    this.$store.dispatch("item_category/getCategory");
    this.$store.dispatch("item_unit/getUnits");
    this.$store.dispatch("accords_note/getAccordsNotes");
    this.$store.dispatch("brand/getBrands");
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.item_detail.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.item_detail.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("item_detail/SET_DELETE_SUCCESS", false);
      }
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.item_detail.isShowResultDialog;
    },
    item() {
      return this.$store.state.item_detail.items;
    },
    filterItems() {
      return this.$store.getters["item_detail/filterItems"];
    },
    filterItemsSold() {
      return this.$store.getters["item_detail/filterItemsSold"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.item_detail.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.item_detail.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.item_detail.isBtnEditLoading;
    },
    convertToListIdValue() {
      var list = [];
      for (const item of this.currencys) {
        list.push({
          id: item.cur_id,
          value: this.$t(item.cur_name),
        });
      }

      return list;
    },
    convertToListIdValueUnits() {
      var boxes = this.$store.state.item_unit.units;
      var list = [];
      for (const item of boxes) {
        list.push({
          id: item.un_id,
          value: item.un_name,
        });
      }

      return list;
    },

    convertToListIdValueCategory() {
      var categorys = this.$store.state.item_category.categorys;
      var list = [];
      for (const item of categorys) {
        list.push({
          id: item.ca_id,
          value: item.ca_name,
        });
      }

      return list;
    },
    accordNotesList() {
      return this.$store.state.accords_note.accordsNotes || [];
    },
    convertToListIdValueBrands() {
      var brands = this.$store.state.brand?.items || [];
      var list = [];
      for (const item of brands) {
        list.push({
          id: item.br_id,
          value: item.br_name,
        });
      }
      return list;
    },
    convertToListIdValueAccordsNotes() {
      var accordsNotes = this.$store.state.accords_note.accordsNotes || [];
      var list = [];
      for (const item of accordsNotes) {
        list.push({
          id: item.an_id,
          value: item.an_name,
        });
      }
      return list;
    },
    headers() {
      return [
        { text: this.$t("purchase_id"), value: "pu_id", sortable: true },
        {
          text: this.$t("suplier"),
          value: "purchase.suplier.su_name",
          sortable: true,
        },
        {
          text: this.$t("purchased_quantity"),
          value: "pui_quantity",
          sortable: true,
        },
        {
          text: this.$t("spent_quantity"),
          value: "pui_out_quantity",
          sortable: true,
        },
        {
          text: this.$t("remain"),
          value: "remaining_quantity",
          sortable: true,
        },
        {
          text: this.$t("cost"),
          value: "pui_cost_price",
          sortable: false,
        },
        {
          text: this.$t("total_cost_remains_item"),
          value: "total_cost",
          sortable: false,
        },
        {
          text: this.$t("currency_type"),
          value: "currency_cur_name",
          sortable: true,
        },
        {
          text: this.$t("dolar_price_when_item_purchased"),
          value: "purchase.pu_main_currency_price",
          sortable: true,
        },

        { text: this.$t("created_at"), value: "created_at", sortable: true },
        {
          text: this.$t("admin"),
          value: "purchase.users.name",
          sortable: true,
        },
      ];
    },
    headersSales() {
      return [
        { text: this.$t("invoice_id"), value: "invoice_id", sortable: true },
        {
          text: this.$t("customer"),
          value: "customer_name",
          sortable: true,
        },
        {
          text: this.$t("sold_quantity"),
          value: "si_quantity",
          sortable: true,
        },

        {
          text: this.$t("cost"),
          value: "si_cost_price",
          sortable: false,
        },
        {
          text: this.$t("sale_price"),
          value: "si_sale_price",
          sortable: false,
        },
        {
          text: this.$t("discount"),
          value: "si_discount",
          sortable: false,
        },
        //total profit
        {
          text: this.$t("total_profit"),
          value: "si_profit",
          sortable: false,
        },
        {
          text: this.$t("sale_type"),
          value: "si_type",
          sortable: true,
        },

        { text: this.$t("created_at"), value: "created_at", sortable: true },
        {
          text: this.$t("admin"),
          value: "user_name",
          sortable: true,
        },
      ];
    },
  },

  methods: {
    async showModal() {
      // Ensure current is set from the item data
      // Try to use this.items first (from getData), then fall back to computed item
      const itemData = (this.items && this.items.item) ? this.items.item : 
                       (this.item && this.item.item) ? this.item.item : null;
      
      if (itemData) {
        // Create a deep copy to avoid reactivity issues
        this.current = JSON.parse(JSON.stringify(itemData));
        
        // Ensure i_packages is initialized as an array
        if (!this.current.i_packages || !Array.isArray(this.current.i_packages)) {
          this.current.i_packages = [];
        }
        
        // Initialize perfume fields
        this.current.i_gender = itemData.i_gender || "";
        this.current.br_id = itemData.br_id || "";
        this.current.i_longevity = itemData.i_longevity || "";
        
        // Initialize images - convert array of paths to objects with preview
        this.item_images = [];
        if (itemData.i_images && Array.isArray(itemData.i_images)) {
          itemData.i_images.forEach((imgPath) => {
            this.item_images.push({
              file: null,
              preview: this.file_url + imgPath,
              existing: imgPath,
            });
          });
        }
        
        // Initialize sizes (currency will come from item's main currency)
        this.item_sizes = [];
        if (itemData.i_sizes && Array.isArray(itemData.i_sizes)) {
          this.item_sizes = itemData.i_sizes.map(size => ({
            is_size: size.is_size || "",
            is_price: size.is_price || 0,
            is_discount: size.is_discount || 0,
          }));
        }
        
        // Initialize seasons
        this.item_seasons = [];
        if (itemData.i_seasons && Array.isArray(itemData.i_seasons)) {
          this.item_seasons = itemData.i_seasons.map(season => ({
            ise_season: season.ise_season || "",
            ise_percentage: season.ise_percentage || 0,
          }));
        }
        
        // Initialize use times
        this.item_use_times = [];
        if (itemData.i_use_times && Array.isArray(itemData.i_use_times)) {
          this.item_use_times = itemData.i_use_times.map(useTime => ({
            iut_type: useTime.iut_type || "",
            iut_percentage: useTime.iut_percentage || 0,
          }));
        }
        
        // Initialize accord notes
        this.item_accord_notes = [];
        if (itemData.i_accord_notes && Array.isArray(itemData.i_accord_notes)) {
          this.item_accord_notes = itemData.i_accord_notes.map(accordNote => ({
            an_id: accordNote.an_id || "",
            ian_percentage: accordNote.ian_percentage || 0,
          }));
        }
      } else {
        console.warn("Item data not available when opening edit modal");
      }
      await this.$refs.editModal.show();
    },
    printReportFunc() {
      this.isHide = true;
      //wait 1 second
      setTimeout(() => {
        var printContents = document.getElementById("printDev").innerHTML;

        // Replace the body's innerHTML with the print contents
        document.body.innerHTML = printContents;
        var isRtl = this.$store.getters["isRtl"];
        // Set direction based on the parameter
        if (isRtl) {
          document.body.style.direction = "rtl";
        } else {
          document.body.style.direction = "ltr";
        }

        // Print the content
        window.print();
        //reload page
      }, 100);
      //print element id invoice_print
    },
    formatNumber(number) {
      return formatNumber(number);
    },
    formatDate(date) {
      return formatDate(date);
    },
    periodChanged(action) {
      this.period = action;

      if (action == "today") {
        this.startDate = moment().format("YYYY-MM-DD");
        this.endDate = moment().format("YYYY-MM-DD");
      } else if (action == "yesterday") {
        this.startDate = moment().subtract(1, "days").format("YYYY-MM-DD");
        this.endDate = moment().subtract(1, "days").format("YYYY-MM-DD");
      } else if (action == "last7days") {
        this.startDate = moment().subtract(7, "days").format("YYYY-MM-DD");
        this.endDate = moment().format("YYYY-MM-DD");
      } else if (action == "last30days") {
        this.startDate = moment().subtract(30, "days").format("YYYY-MM-DD");
        this.endDate = moment().format("YYYY-MM-DD");
      } else if (action == "thismonth") {
        this.startDate = moment().startOf("month").format("YYYY-MM-DD");
        this.endDate = moment().endOf("month").format("YYYY-MM-DD");
      } else if (action == "lastmonth") {
        this.startDate = moment()
          .subtract(1, "months")
          .startOf("month")
          .format("YYYY-MM-DD");
        this.endDate = moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD");
      } else if (action == "lastyear") {
        this.startDate = moment()
          .subtract(1, "years")
          .startOf("year")
          .format("YYYY-MM-DD");
        this.endDate = moment()
          .subtract(1, "years")
          .endOf("year")
          .format("YYYY-MM-DD");
      } else if (action == "thisyear") {
        this.startDate = moment().startOf("year").format("YYYY-MM-DD");
        this.endDate = moment().endOf("year").format("YYYY-MM-DD");
      }
      //all
      else if (action == "all") {
        this.startDate = "2000-01-01";
        this.endDate = moment().endOf("year").format("YYYY-MM-DD");
      }

      this.getData();
    },

    async getData() {
      var res = await this.$store.dispatch("item_detail/getItems", {
        i_id: this.$route.params.id,
        startDate: this.startDate,
        endDate: this.endDate,
        invoiceType: this.invoiceType,
      });
      //check res status

      if (res.status == 200) {
        this.items = res.data;
        // Create a deep copy to avoid reactivity issues
        this.current = JSON.parse(JSON.stringify(this.items.item));
        // Ensure i_packages is initialized as an array
        if (!this.current.i_packages || !Array.isArray(this.current.i_packages)) {
          this.current.i_packages = [];
        }
        // Load accord notes data if we have accord note IDs
        if (this.items.item && this.items.item.i_accord_notes && Array.isArray(this.items.item.i_accord_notes)) {
          const accordsNotes = this.$store.state.accords_note.accordsNotes || [];
          // Build map
          accordsNotes.forEach(an => {
            this.accordNotesMap[an.an_id] = an;
          });
          
          // Merge accord note data into i_accord_notes
          this.items.item.i_accord_notes.forEach(accordNote => {
            if (this.accordNotesMap[accordNote.an_id]) {
              accordNote.accordsNote = this.accordNotesMap[accordNote.an_id];
            }
          });
        }
        
        // Debug: Log the item data to see what we're getting
        console.log("Item Data:", this.items.item);
        console.log("Item Images:", this.items.item?.i_images);
        console.log("Item Sizes:", this.items.item?.i_sizes);
        console.log("Item Seasons:", this.items.item?.i_seasons);
        console.log("Item Use Times:", this.items.item?.i_use_times);
        console.log("Item Accord Notes:", this.items.item?.i_accord_notes);
      } else if (res.response && res.response.status == 404) {
        window.open("/item-list", "_self");
      }
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (
        this.checkRulesIsError(this.current.i_name, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(this.current.i_sale_price, "edit", this.rules)
          .isError
      ) {
        this.$store.state.item_detail.isBtnEditLoading = false;
        return;
      }
      this.$store.state.item_detail.isBtnEditLoading = true;

      // Handle packages: ensure we send packages even if empty
      let packages = this.current.i_packages;
      if (!packages || !Array.isArray(packages)) {
        packages = []; // Ensure it's always an array
      }
      
      // Validate packages: each package must have a name
      if (packages.length > 0) {
        for (let i = 0; i < packages.length; i++) {
          if (!packages[i].name || packages[i].name.trim() === '') {
            this.$store.state.item_detail.isBtnEditLoading = false;
            alert(this.$t('package_name_required') || 'Package name is required for all packages');
            return;
          }
        }
      }

      // Prepare FormData for file uploads (similar to AddItem)
      const formData = new FormData();
      formData.append("i_name", this.current.i_name);
      formData.append("i_barcode", this.current.i_barcode || "");
      formData.append("i_show", this.current.i_show !== undefined ? this.current.i_show : 1);
      formData.append("i_is_famous", this.current.i_is_famous !== undefined ? this.current.i_is_famous : 0);
      formData.append("i_state", this.current.i_state !== undefined ? this.current.i_state : 1);
      formData.append("i_link", this.current.i_link || "");
      formData.append("ca_id", this.current.ca_id);
      formData.append("un_id", this.current.un_id);
      formData.append("cur_id", this.current.cur_id);
      formData.append("i_sale_price", this.current.i_sale_price);
      formData.append("i_sale_price_jwmla", this.current.i_sale_price_jwmla || 0);
      formData.append("i_discount", this.current.i_discount || 0);
      
      // Only append nullable fields if they have a value
      if (this.current.i_main_currency_price !== null && this.current.i_main_currency_price !== undefined && this.current.i_main_currency_price !== '') {
        formData.append("i_main_currency_price", this.current.i_main_currency_price);
      }
      if (this.current.i_expire_date !== null && this.current.i_expire_date !== undefined && this.current.i_expire_date !== '') {
        formData.append("i_expire_date", this.current.i_expire_date);
      }
      
      formData.append("i_desc", this.current.i_desc || "");
      
      // Perfume fields
      formData.append("i_gender", this.current.i_gender || "");
      formData.append("br_id", this.current.br_id || "");
      formData.append("i_longevity", this.current.i_longevity || "");
      
      // Packages
      if (packages && packages.length > 0) {
        formData.append("i_packages", JSON.stringify(packages));
      }
      
      // Multiple images - include existing images and new files
      const existingImages = [];
      this.item_images.forEach((img, index) => {
        if (img.file) {
          formData.append(`images[${index}][file]`, img.file);
        } else if (img.existing) {
          existingImages.push(img.existing);
        }
      });
      if (existingImages.length > 0) {
        formData.append("existing_images", JSON.stringify(existingImages));
      }
      
      // Sizes - always send, even if empty (to allow clearing all sizes)
      const sizesToSend = (this.item_sizes || []).map(size => ({
        is_size: size.is_size,
        is_price: size.is_price || 0,
        is_discount: size.is_discount || 0,
        cur_id: size.cur_id || this.current.cur_id || null
      })).filter(size => size.is_size && size.is_size.trim() !== "");
      formData.append("sizes", JSON.stringify(sizesToSend));
      
      // Seasons
      if (this.item_seasons && this.item_seasons.length > 0) {
        const seasonsToSend = this.item_seasons.filter(s => s.ise_season && s.ise_percentage !== undefined);
        if (seasonsToSend.length > 0) {
          formData.append("seasons", JSON.stringify(seasonsToSend));
        }
      }
      
      // Use times
      if (this.item_use_times && this.item_use_times.length > 0) {
        const useTimesToSend = this.item_use_times.filter(ut => ut.iut_type && ut.iut_percentage !== undefined);
        if (useTimesToSend.length > 0) {
          formData.append("use_times", JSON.stringify(useTimesToSend));
        }
      }
      
      // Accord notes
      if (this.item_accord_notes && this.item_accord_notes.length > 0) {
        const accordNotesToSend = this.item_accord_notes.filter(an => an.an_id && an.ian_percentage !== undefined);
        if (accordNotesToSend.length > 0) {
          formData.append("accord_notes", JSON.stringify(accordNotesToSend));
        }
      }

      formData.append("i_id", this.current.i_id);
      
      var res = await this.$store.dispatch("item_list/editItem", formData);

      this.isSubmitedEdit = false;
      this.$store.state.item_detail.isBtnEditLoading = false;
      if (res.status == 200) {
        this.$refs.editModal.hide();
        this.getData();
      } else {
        // Handle error case
        console.error("Edit failed:", res);
      }
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";

      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    openImageModal(imageUrl) {
      this.$refs.imageModal.show(imageUrl);
    },
    async showEditModal() {
      await this.showModal();
    },
    getSeasonIcon(season) {
      const icons = {
        spring: 'fa-solid fa-seedling text-green-500',
        summer: 'fa-solid fa-sun text-orange-500',
        autumn: 'fa-solid fa-leaf text-orange-600',
        winter: 'fa-solid fa-snowflake text-blue-500',
      };
      return icons[season] || 'fa-solid fa-calendar text-gray-500';
    },
    getCurrencyName(curId) {
      if (!curId || !this.item || !this.item.item || !this.item.item.currency) return '';
      // If it's the same currency as item, use item's currency name
      if (curId == this.item.item.cur_id) {
        return this.$t(this.item.item.currency.cur_name);
      }
      // Otherwise, try to find it from currencies list
      const currency = this.currencys.find(c => c.cur_id == curId);
      return currency ? this.$t(currency.cur_name) : '';
    },
    // Methods for managing dynamic fields
    addImage() {
      this.item_images.push({ file: null, preview: null, existing: null });
    },
    removeImage(index) {
      this.item_images.splice(index, 1);
    },
    addSize() {
      this.item_sizes.push({
        is_size: "",
        is_price: 0,
        is_discount: 0,
      });
    },
    removeSize(index) {
      this.item_sizes.splice(index, 1);
    },
    addSeason() {
      this.item_seasons.push({
        ise_season: "",
        ise_percentage: 0,
      });
    },
    removeSeason(index) {
      this.item_seasons.splice(index, 1);
    },
    addUseTime() {
      this.item_use_times.push({
        iut_type: "",
        iut_percentage: 0,
      });
    },
    removeUseTime(index) {
      this.item_use_times.splice(index, 1);
    },
    addAccordNote() {
      this.item_accord_notes.push({
        an_id: "",
        ian_percentage: 0,
      });
    },
    removeAccordNote(index) {
      this.item_accord_notes.splice(index, 1);
    },
    updateImageFile(index, file) {
      if (this.item_images[index]) {
        this.item_images[index].file = file;
        if (file) {
          this.item_images[index].preview = URL.createObjectURL(file);
        } else if (this.item_images[index].existing) {
          this.item_images[index].preview = this.file_url + this.item_images[index].existing;
        } else {
          this.item_images[index].preview = null;
        }
      }
    },
    addPackage() {
      if (!this.current.i_packages) {
        this.current.i_packages = [];
      }
      this.current.i_packages.push({
        name: "",
        quantity: 1,
        price: 0,
      });
    },
    removePackage(index) {
      if (this.current.i_packages) {
        this.current.i_packages.splice(index, 1);
      }
    },
  },
};
</script>
